import { handleActions } from "redux-actions";

import {
    CAMPAIGNS_FAILURE,
    CAMPAIGNS_FILTER_CHANGE,
    CAMPAIGNS_REQUEST_START,
    CAMPAIGNS_RESULT,
    CAMPAIGNS_SORT_CHANGE,
    CAMPAIGNS_SEARCH_CHANGE,
    CAMPAIGNS_EDIT_START,
    CAMPAIGNS_EDIT_SUCCESS,
    CAMPAIGNS_ARCHIVE_CHANGE,
} from "constants/action-types";

const initialState = {
    result: [],
    isFetching: false,
    error: undefined,
    nextPage: undefined,
    hasMoreResults: false,
    filters: undefined,
    isDeleting: false,
    __sort: "created_on",
    __sort_order: "desc",
    __search: "",
};

const campaignsReducer = handleActions(
    {
        [CAMPAIGNS_REQUEST_START]: (state, { payload = {} }: any) => {
            return Object.assign({}, state, {
                result: payload.reset ? [] : state.result,
                isFetching: true,
                nextPage: undefined,
                hasMoreResults: false,
            });
        },
        [CAMPAIGNS_RESULT]: (state, { payload, meta = {}, error }: any) => {
            let result;
            if (error) {
                result = state.result;
            } else if (meta.replace) {
                result = payload;
            } else {
                result = state.result.concat(payload);
            }

            return Object.assign({}, state, {
                result,
                nextPage: meta.next,
                hasMoreResults: !!meta.next,
                isFetching: false,
                error: error ? payload : error,
            });
        },
        [CAMPAIGNS_FAILURE]: (state, { payload, error }) => {
            const { nextPage } = state;
            return Object.assign({}, state, {
                isFetching: false,
                error: error ? payload : undefined,
                hasMoreResults: !!nextPage,
            });
        },
        [CAMPAIGNS_SEARCH_CHANGE]: (state, { payload }: any) => {
            const { search } = payload;
            const filters = state.filters.set("__search", search);
            return Object.assign({}, state, { __search: search, filters });
        },
        [CAMPAIGNS_FILTER_CHANGE]: (state, { payload }) => {
            const { filters } = payload;
            return Object.assign({}, state, { filters, __search: filters.get("__search") });
        },
        [CAMPAIGNS_SORT_CHANGE]: (state, { payload }) => {
            const { __sort, __sort_order } = payload;
            return Object.assign({}, state, { __sort, __sort_order });
        },
        [CAMPAIGNS_EDIT_START]: (state, { payload }: any) => {
            return Object.assign({}, state, { isDeleting: payload.id });
        },
        [CAMPAIGNS_EDIT_SUCCESS]: (state) => {
            return Object.assign({}, state, { isDeleting: false });
        },
        [CAMPAIGNS_ARCHIVE_CHANGE]: (state, { payload }: any) => {
            const result = state.result.filter((campaignId) => {
                return campaignId !== payload.id;
            });
            return Object.assign({}, state, { isDeleting: false, result });
        },
    },
    initialState
);

export default campaignsReducer;
